/**
 * 全局数据
 */
var Global = function (cfg) {};
Global.prototype = {
    rechargeOption: [],

    selectedOption: {},

    setRechargeOption: function (optionList) {
        this.rechargeOption = optionList;
    },

    setSelectedOption: function (option) {
        this.selectedOption = option;
    },
    getProjectVersion() {
        const version = PROJECT_VERSION.split(".");
        version.splice(2, 0, "0");
        return version.join(".");
    },
    execute(action) {
        return new Promise((resolve, reject) => {
            grecaptcha.enterprise.ready(function () {
                grecaptcha.enterprise
                    .execute("6LehykohAAAAAMpbs7zayi9a1ARwcBGeSOjrxkyK", { action })
                    .then(function (token) {
                        resolve(token);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        });
    }
};
module.exports = new Global();



// WEBPACK FOOTER //
// ./js/global/global.js